// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spinner {\n  all: initial;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 4rem 0 4rem 0;\n}\n.spinner circle {\n  fill: #005BA5;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
